const FECHA_CORTA = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const MEDIA = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 })

const SOLO_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * El dia, sin hora. `fecha_ultimo_albaran` llega como fecha pelada y
 * `fecha_ultimo_aviso` con hora; en la tabla solo interesa el dia.
 */
export function formatearFechaCorta(valor: string | null | undefined): string | null {
  if (!valor) return null

  const partes = SOLO_FECHA.exec(valor)
  // Una fecha sin hora la interpreta `new Date` como medianoche **UTC**, de modo
  // que al formatearla en un huso al oeste de Greenwich sale el dia anterior.
  // Construida por partes es hora local y el dia es el que dice la cadena.
  const fecha = partes
    ? new Date(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3]))
    : new Date(valor)

  return Number.isNaN(fecha.getTime()) ? null : FECHA_CORTA.format(fecha)
}

/** La media de semanas sin pedir, con la coma decimal espanola. */
export function formatearMedia(valor: number): string {
  return MEDIA.format(valor)
}

/**
 * El estado en plural, que es como se lee en un desplegable de filtro ("todos
 * los avisados") y en el resumen de filtros activos. La insignia de la fila usa
 * el singular y lo saca del propio valor.
 */
const PLURALES: Record<string, string> = {
  pendiente: 'Pendientes',
  avisado: 'Avisados',
}

export function etiquetaEstadoPlural(estado: string): string {
  return PLURALES[estado] ?? estado
}
